import React from 'react';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';
import { TableVirtuoso } from 'react-virtuoso';

export const Table = styled.table`
  max-height: 800px;
  table-layout: fixed;
  padding: 32px 0;
  flex-grow: 1;
`;

export const TableWrapper = styled.div`
  display: flex;
`;

export const DataEntryHeaderRowLayout = styled('tr')`
  background-color: ${colors.pearl};
  // Ensures there's a "bottom border", but doesn't change the height
  box-shadow: 0 1px 0 ${colors.silt};
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  text-transform: uppercase;
  white-space: pre-wrap;
`;

type DataEntryHeaderCellLayoutProps = {
  width: number;
};

export const DataEntryHeaderCellLayout = styled('th')<DataEntryHeaderCellLayoutProps>`
  width: ${props => props.width}px;
`;

export const DataEntryRowLayout = React.memo(styled('tr')<{ hasBackgroundColor }>`
  background-color: ${colors.white};
  // Ensures there's a "top border", but doesn't change the height
  box-shadow: 0 -1px 0 ${colors.silt};
  cursor: pointer;
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  position: relative;
  white-space: pre-wrap;
  &:hover {
    background-color: ${colors.brook};
  }
  ${({ hasBackgroundColor }) => hasBackgroundColor && `background-color: ${colors.shell}`};
`);

export const DataEntryTableBottomGradient = styled('div')`
  background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  bottom: 0;
  height: 64px;
  left: 0;
  position: absolute;
  width: 100%;
`;

export const DataEntryTableVirtuoso = styled(TableVirtuoso)`
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
`;
